import React from 'react';
import './index.css';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'
import * as serviceWorker from './serviceWorker';
import { v4 as uuidv4 } from 'uuid';
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache';
import { createRoot } from 'react-dom/client';
import { AwsRum } from 'aws-rum-web';
import config from './config.json'
import { loadWAFEnv } from './aws-waf-captcha/util';

const nonce = btoa(uuidv4())

const cache = createCache({
    key: 'entauth',
    nonce: nonce,
    prepend: true
})

// Load WAF environment variables first
await loadWAFEnv()

const root = createRoot(document.getElementById('root'));

try {

  const rumData = config.rum_app_monitors.find(obj => obj.domains.includes(window.location.hostname))

  if (rumData && rumData.app_id && rumData.region) {

    const rumConfig = {
      sessionSampleRate: rumData.sessionSampleRate,
      guestRoleArn: rumData.guestRoleArn,
      identityPoolId: rumData.identityPoolId,
      endpoint: rumData.endpoint,
      telemetries: ["http","errors","performance"],
      allowCookies: true,
      enableXRay: true
    };

    const APPLICATION_ID = rumData.app_id;
    const APPLICATION_VERSION = rumData.app_version;
    const APPLICATION_REGION = rumData.region;

    const awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      rumConfig
    );
  }
} catch (error) {
  console.log("App monitor error", error)
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

if (window.self === window.top) {
    root.render(
        <React.StrictMode>
            <I18nextProvider i18n={i18n}>
                <CacheProvider value={cache}>
                    <App />
                </CacheProvider>
            </I18nextProvider>
        </React.StrictMode>,
    );
} else {
    root.render(<p>Unable to load application, please refresh browser tab.</p>);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
